import { IChooseItems } from '../../../../components/mainContent/TableAllDishes'
import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import React, { useState } from 'react'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useTranslation } from 'react-i18next'
import { IBuffetMilletDto } from '../../../../core/api/dto/BuffetMilletDto'
import {
  useDeleteMilletToFotoboxesMutation,
  useSendMilletToFotoboxesMutation,
} from '../../../../core/api/BuffetMilletApi'
import { uniqFilter } from '../../DishesPage/hooks/useSentOnFotobox'

interface UseSentMilletOnFotoboxProps {
  chooseItems: IChooseItems | null
  tableData: IBuffetMilletDto[]
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
}

interface UseSentMilletOnFotoboxResponse {
  isDeleteMode: boolean
  deleteStations: IEdgeServers[] | null
  sentPopup: boolean
  closeSentPopup: () => void
  openDeleteStationPopup: () => void
  openSentPopup: () => void
  onSendMillet: (value: string[]) => void
  onDeleteMilletStation: (value: string[]) => void
  isLoadingSend: boolean
}

export const useSentMilletOnFotobox = ({
  tableData,
  chooseItems,
  setChooseItems,
}: UseSentMilletOnFotoboxProps): UseSentMilletOnFotoboxResponse => {
  const { t } = useTranslation()
  const [sentPopup, setSentPopup] = useState(false)
  const [isDeleteMode, setIsDeleteMode] = useState(false)
  const [deleteStations, setDeleteStations] = useState<IEdgeServers[] | null>(
    null,
  )

  const [sendMilletToFotoboxes, { isLoading: isLoadingSend }] =
    useSendMilletToFotoboxesMutation()
  const [deleteMilletToFotoboxes] = useDeleteMilletToFotoboxesMutation()

  const chooseMillets = tableData
    .filter(
      (item) =>
        chooseItems &&
        chooseItems[item.id] &&
        !item.archived &&
        !item.isDefault,
    )
    .map((item) => item.guid)

  const closeSentPopup = () => {
    setSentPopup(false)
    setIsDeleteMode(false)
    setDeleteStations(null)
  }
  const openDeleteStationPopup = () => {
    setSentPopup(true)
    setIsDeleteMode(true)
    const deleteStation = uniqFilter(
      tableData
        .filter((item) => chooseItems && chooseItems[item.id] && !item.archived)
        .map((item) => item.edgeServers)
        .flat(1),
    )
    setDeleteStations(deleteStation)
  }
  const openSentPopup = () => setSentPopup(true)

  const onSendMillet = (value: string[]) => {
    if (value.length && chooseMillets.length) {
      sendMilletToFotoboxes({
        milletsGuids: chooseMillets,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Тары успешно отправлены на выбранные станции'),
          })
          setChooseItems(null)
          setSentPopup(false)
        })
    }
  }
  const onDeleteMilletStation = (value: string[]) => {
    if (value.length && chooseMillets.length) {
      deleteMilletToFotoboxes({
        milletsGuids: chooseMillets,
        edgeServersGuids: value,
      })
        .unwrap()
        .then(() => {
          AppNotification({
            type: NotificationType.success,
            msg: t('Тары успешно удалены с выбранных станций'),
          })
          setChooseItems(null)
          setSentPopup(false)
          setIsDeleteMode(false)
          setDeleteStations(null)
        })
    }
  }

  return {
    isDeleteMode,
    deleteStations,
    sentPopup,
    closeSentPopup,
    openSentPopup,
    openDeleteStationPopup,
    onDeleteMilletStation,
    onSendMillet,
    isLoadingSend,
  }
}
